import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { DeviceTypeForm, DeviceTypeQuery, DeviceTypeVO } from '@/api/console/deviceType/types';

/**
 * 查询空巡卫士-设备类型列表
 * @param query
 * @returns {*}
 */
export const listDeviceType = (query) => {
  return request({
    url: '/apg/deviceType/list',
    method: 'get',
    params: query
  });
};

/**
 * 查询空巡卫士-设备类型集合
 * @param query
 */
export const listDeviceTypeData = (query) => {
  return request({
    url: '/apg/deviceType/getList',
    method: 'get',
    params: query
  });
};

/**
 * 查询空巡卫士-设备类型详细
 * @param id
 */
export const getDeviceType = (id: string | number) => {
  return request({
    url: '/apg/deviceType/' + id,
    method: 'get'
  });
};

/**
 * 新增空巡卫士-设备类型
 * @param data
 */
export const addDeviceType = (data) => {
  return request({
    url: '/apg/deviceType',
    method: 'post',
    data: data
  });
};

/**
 * 修改空巡卫士-设备类型
 * @param data
 */
export const updateDeviceType = (data) => {
  return request({
    url: '/apg/deviceType',
    method: 'put',
    data: data
  });
};

/**
 * 删除空巡卫士-设备类型
 * @param id
 */
export const delDeviceType = (id: string | number | Array<string | number>) => {
  return request({
    url: '/apg/deviceType/' + id,
    method: 'delete'
  });
};

/**获取维护记录列表 */
export const deviceMaintainRecordList = (params) => {
  return request({
    url: '/apg/deviceMaintainRecord/list',
    method: 'get',
    params
  });
};
/**新增维护记录 */
export const addDeviceMaintainRecord = (data) => {
  return request({
    url: '/apg/deviceMaintainRecord',
    method: 'post',
    data
  });
};
/**编辑维护记录 */
export const editDeviceMaintainRecord = (data) => {
  return request({
    url: '/apg/deviceMaintainRecord',
    method: 'put',
    data
  });
};
/**删除维护记录 */
export const deleteDeviceMaintainRecord = (ids) => {
  return request({
    url: `/apg/deviceMaintainRecord/${ids}`,
    method: 'delete'
  });
};

/**新增能力集*/
export const addCapability = (data) => {
  return request({
    url: '/apg/deviceCapability',
    method: 'post',
    data
  });
};
/**修改能力集*/
export const updateCapability = (data) => {
  return request({
    url: '/apg/deviceCapability',
    method: 'put',
    data
  });
};
/**删除能力集*/
export const delCapability = (ids) => {
  return request({
    url: `/apg/deviceCapability/${ids}`,
    method: 'delete'
  });
};
/**能力集树*/
export const getCapabilityTree = (params = {}) => {
  return request({
    url: '/apg/deviceCapability/tree',
    method: 'get',
    params
  });
};
